(function(){

    // Example function for creating the emitter
	/*
		// Create particle emitter
		p.createParticleEmitter = function(){
			// Create the display object or an array of display objects we want as the particles

			var shape = new createjs.Shape();
			shape.graphics.beginFill("#ff0000").drawRect(0, 0, 10, 10);
			 OR
			var shapes = [
				shape1,
				shape2,
				etc
			];

			// Settings for the particle you want
			var particle = {
				shape: shape,
				lifetime: {min: 10, max: 10},
				speed: {min: 2, max: 4},
				rotateSpeed: {min:-3, max:3},
				scale: {start: 1, end: 0.6},
				opacity: {start: 1, end: 1},
				force: {x: 0, y: -7},
				gravity: {on: true, speed: 2.5}
			};

			// Settings for the emitter
			var emitterSettings = {
				pos: {x: 0, y: 0},
				particle: particle,
				count: 100,
				rate: 0.05,
				loop: true,
				burst: false,
				startOn: true
			};

			this.particleEmitter = new cjs.ParticleEmitter(emitterSettings);
			this.addChild(this.particleEmitter);
		};
	*/

    function ParticleEmitter(settings){
        this.Container_constructor();

        settings = settings || {};
        // Position
        this.x = settings.pos && settings.pos.x ? settings.pos.x : 0;
        this.y = settings.pos && settings.pos.y ? settings.pos.y : 0;

        // Container to add the children to if not this container
        this.particleContainer = settings.particleContainer ? settings.particleContainer : null;

        // Properties
        this.count = settings.count ? settings.count : 5; // Number of particles on screen at once
        this.rate = settings.rate ? settings.rate : 0; // How fast particles spawn
        this.loop = settings.loop !== undefined ? settings.loop : false; // Loop the particle system or play only once?
        this.burst = settings.burst !== undefined ? settings.burst : false; // Burst all the particles at once
        this.spawn = 0; // Timer to spawn

        // Particle graphic representation
        this.particle = settings.particle;
        this.particles = []; // Array of all created currently running particles
        if (settings.startOn) {
            this.ready = true;
        } else {
            this.ready = false;
        }
        this.particleTracker = 0;
        this.rateTracker = 0;

        // Create the start pool
        this.createPool();
    }

    var p = cjs.extend(ParticleEmitter, cjs.Container);

    /** Update tick called internally - handled by CreateJS */
    p._tick = function (e) {
        var tick = e.delta * 0.001;

        /** Code here */
        var i;
        // For each particle call the update on it for position changes
        for (i = 0; i < this.particles.length; i++) {
            // Update particle then check if it died
            if (this.particles[i].isPlaying) {
                this.particles[i].update(tick);
            }
        }

        // Don't create any more particles
        if (!this.ready) {
            return;
		}

        // If particles length is under the count
        if (this.burst) {
            // Check if all the particles are ready for another burst
            if (!this.checkReady()) {
                return;
            }

            // Create particles for a burst
            for (i = 0; i < this.count; i++) {
                // Play the particle
                this.particles[i].play(this.particleContainer);
            }

            // If the emitter is only supposed to play once then stop it
            if (!this.loop) {
                this.stop();
            }
        } else {
            // Time tracking for rate
            this.spawn -= tick;
            if (this.spawn <= 0) {
                // Start the next particle in line if the particle is ready(reset)
                if (this.particles[this.rateTracker].isReady) {
                    this.particles[this.rateTracker].play(this.particleContainer);
                } else {
                    return;
                }

                // Reset spawn for next particle
                this.spawn = this.rate;

                // Track the particle position to play
                this.rateTracker++;
                if (this.rateTracker > this.count - 1) {
                    this.rateTracker = 0;
                }

                // Keep track of how many particles are created if loop is false
                if (!this.loop) {
                    this.particleTracker++;
                }
            }

            // If the emitter is only supposed to play once then stop it when the amount of particles created is greater then or equal to count
            if (!this.loop && this.particleTracker >= this.count) {
                this.stop();
            }
        }

        this.Container__tick(e);
    };

    // Play the emitter
	p.play = function(){
		// Loop is false reset the particle tracker and ready the emitter
		if(!this.loop){
			this.particleTracker = 0;
		}
		this.ready = true;
	};

	// Stop the emitter
	p.stop = function(){
		this.ready = false;
	};

    // Create all the objects in a pool
    p.createPool = function() {
        for (var i = 0; i < this.count; i++) {
            var particle = new cm.Particle(this.particle, this);
            particle.set();
            this.particles.push(particle);
            if (this.particleContainer) {
                this.particleContainer.addChild(particle.shape);
            } else {
                this.addChild(particle.shape);
            }
        }
	};

	// Check if all the particles are ready to play again (burst)
	p.checkReady = function(){
		var i, numReady = 0;
		for(i = 0; i < this.particles.length; i++){
			// Check if particles are ready to play
			if(this.particles[i].isReady){
				numReady++;
			}
		}

		// Check if all the particles are ready and return true if they are
		if(numReady >= this.count){
			return true;
		}else{
			return false;
		}
	};

	// Change the particles being emitted at runtime
	p.change = function( newParticle ){
        this.stop();
        this.particles = [];
        this.particle = newParticle;
        for (var i = 0; i < this.count; i++) {
            var particle = new cm.Particle(this.particle, this);
            particle.set();
            this.particles.push(particle);
            if (this.particleContainer) {
                this.particleContainer.addChild(particle.shape);
            } else {
                this.addChild(particle.shape);
            }
        }
        this.play();
	};

    window.cm = window.cm || {};
    cm.ParticleEmitter = cjs.promote(ParticleEmitter, 'Container');

})();

/**
 * Individual Particle created by the particle emitter based on settings provided by user
 */
(function(){

    function Particle(settings, emitter){
        // Setup particle settings
        if (settings.shape instanceof Array) {
            this.shape = settings.shape.random().clone();
        } else {
            this.shape = settings.shape.clone();
        }

        this.lifetime = settings.lifetime;
        this.currentLifetime = 0;
        this.speed = settings.speed;
        this.currentSpeed = 0;
        this.rotateSpeed = settings.rotateSpeed;
        this.currentRotateSpeed = 0;
        this.scale = settings.scale;
        this.opacity = settings.opacity;
        this.force = settings.force;
        this.gravity = settings.gravity;
        this.position = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.container = settings.container;

        this.emitter = emitter;
    }

    var p = Particle.prototype;

    p.update = function(dt){
        // Subtract time from lifetime of particle
        this.currentLifetime -= dt;

        // If the user wants gravity
        if (this.gravity.on) {
            this.velocity.y += dt * this.gravity.speed;
        }

        // Set shapes position to the new position given the provided velocity
        this.shape.x = this.position.x;
        this.shape.y = this.position.y;
        this.shape.rotation = 0;
        this.position.x += this.velocity.x;
        this.position.y += this.velocity.y;

        // Set scale based on lifetime
        if (this.scale.start !== this.scale.end) {
            this.shape.scaleX = this.shape.scaleY = Math.map(this.currentLifetime, this.lifetime.max, 0, this.scale.start, this.scale.end);
        }

        // Set opacity based on lifetime
        if (this.opacity.start !== this.opacity.end) {
            this.shape.alpha = Math.map(this.currentLifetime, this.lifetime.max, 0, this.opacity.start, this.opacity.end);
        }

        // Check if the particle needs to die
        this.isDead();
    };

    /** Lifetime has ended or its not visible on the screen anymore */
    p.isDead = function(){
        if(this.currentLifetime < 0){
            this.set();
        }
    };

    /** Return a random direction */
    p.randomDir = function(){
        var randNum = Math.random();
        var fiftyFifty = Math.random();
        if(fiftyFifty < 0.5){
            randNum = -randNum;
        }
        return randNum;
    };

    /** Get a random rotation */
    p.randomRot = function(){
        return Math.random() * 360;
    };

    /** Reset the particle's position and give some new randomness for pool */
    p.set = function(){
        // Reset position scale alpha and rotation
        this.shape.x = this.position.x = 0;
        this.shape.y = this.position.y = 0;
        this.shape.scaleX = this.shape.scaleY = this.scale.start;
        this.shape.alpha = this.opacity.start;
        this.velocity = { x: this.randomDir(), y: this.randomDir() };
        this.shape.rotation = this.randomRot();

        // If random lifetime range
        if (this.lifetime.min !== this.lifetime.max) {
            this.currentLifetime = (Math.random() * (this.lifetime.max - this.lifetime.min)) + this.lifetime.min;
        } else {
            this.currentLifetime = this.lifetime.min;
        }

        // If random velocity range
        if (this.speed.min !== this.speed.max) {
            this.currentSpeed = (Math.random() * (this.speed.max - this.speed.min)) + this.speed.min;
        } else {
            this.currentSpeed = this.speed.min;
        }

        // Set velocity and increase it by the speed
        if (this.currentSpeed !== 0) {
            this.velocity.x *= this.currentSpeed;
            this.velocity.y *= this.currentSpeed;
        }

        // Add a force if provided
        if (this.force.x !== 0 || this.force.y !== 0) {
            this.velocity.x += this.force.x;
            this.velocity.y += this.force.y;
        }

        // If random rotation range
        if (this.rotateSpeed.min !== this.rotateSpeed.max) {
            this.currentRotateSpeed = (Math.random() * (this.rotateSpeed.max - this.rotateSpeed.min)) + this.rotateSpeed.min;
        } else {
            this.currentRotateSpeed = this.rotateSpeed.min;
        }

        // Stop particle
        this.stop();
	};

	/** Set the position of the sprite relative to the particle emitters position inside the sprite's parent */
	p.setPosition = function(container) {
		var point = container.localToLocal(0, 0, this.emitter);
		this.shape.x = this.position.x = point.x;
		this.shape.y = this.position.y = point.y;
	};


    /** Start playing the particle */
    p.play = function(container) {
        if (container) {
            this.setPosition(container);
        }
        this.isPlaying = true; // Particle is now playing
        this.shape.visible = true;
        this.isReady = false; // Particle wont be ready to play again till it's lifetime is over and it stops
    };

    /** Stop the particle */
    p.stop = function() {
        if(this.isPlaying){
            if(cm.ViewControl.current.handleDeadParticle)
                cm.ViewControl.current.handleDeadParticle();
        }
        this.isPlaying = false; // Is currently playing?
        this.shape.visible = false;
        this.isReady = true; // Is the particle ready to play (For rate emitter)
    };

    window.cm = window.cm || {};
    cm.Particle = Particle;

})();